import React, { Component } from 'react';
import classes from './LogViewFilters.module.css';
import { CategoriesFilter, DatesFilter, FileTypeFilter, KeywordsFilter, LocationsFilter, SeasonsFilter, TagsFilter } from 'components/Filters';
import SliderToggle from 'components/UI/SliderToggle/SliderToggle';
import MembersFilter from 'containers/Filters/MembersFilter/MembersFilter';
import { combineAndDedupArrays, formatDateForDisplay, preparePostDateForSubmission, truncateText, updateObject } from 'shared/utility';

class LogViewFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unreadOnly: false,
      locationsOnly: false,
      activeFilter: null,
      keywordsInput: '',
      keywords: [],
      dateStart: null,
      memberIds: [],
      seasons: [],
      categories: [],
      locations: [],
      tags: {
        whatTags: [],
        whoTags: [],
        locationTags: [],
      },
      fileType: '',
      isChanged: false,
    };
    this.container = React.createRef();
  }

  componentDidMount() {
    if (this.props.filteringSet) {
      this.handleSetFilters();
    }
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.show && prevProps.show) {
      this.setState({ activeFilter: null });
    } else if (this.props.show && !prevProps.show) {
      if (this.props.filteringSet) {
        this.handleSetFilters();
      }
    } else if (this.props.filters !== prevProps.filters) {
      this.handleSetFilters();
    }
  }

  handleSetFilters = () => {
    const keywordsInput = this.props.filters.keywords.join(', ');
    this.setState({
      unreadOnly: this.props.filters.unreadOnly,
      locationsOnly: this.props.filters.locationsOnly,
      dateStart: this.props.filters.dateStart ? this.props.filters.dateStart : null,
      seasons: this.props.filters.seasons,
      keywords: this.props.filters.keywords,
      keywordsInput,
      categories: this.props.filters.categories,
      memberIds: this.props.filters.memberIds,
      locations: this.props.filters.locations,
      tags: this.props.filters.tags,
      fileType: this.props.filters.fileType,
    });
  };

  handleClearAll = () => {
    this.setState({
      unreadOnly: false,
      locationsOnly: false,
      keywords: [],
      dateStart: preparePostDateForSubmission(new Date()),
      categories: [],
      seasons: [],
      memberIds: [],
      locations: [],
      tags: { whatTags: [], whoTags: [], locationTags: [] },
      keywordsInput: '',
      fileType: '',
    });
    this.props.handleClearAllFilters();
  };

  toggleBooleanFilter = (filterName) => {
    this.setState({ unreadOnly: !this.state[filterName] });
    this.props.handleFilterUpdate(!this.state[filterName], filterName);
  };

  toggleLocationsOnly = () => {
    this.setState({ locationsOnly: !this.state.locationsOnly, locations: [] });
  };

  toggleFilter = (filterName) => {
    if (this.state.activeFilter === filterName) {
      if (this.state.isChanged) this.handleFilterSubmit(filterName);
      this.setState({ activeFilter: null, isChanged: false });
    } else {
      if (this.state.activeFilter !== null && this.state.isChanged) this.handleFilterSubmit(this.state.activeFilter);
      this.setState({ activeFilter: filterName, isChanged: false });
    }
  };

  keywordsChangedHandler = (event) => {
    const keywords = event.target.value.replace(', ', ',').split(',');
    this.setState({ keywords, keywordsInput: event.target.value, isChanged: true });
  };

  handleDateStartChanged = (dateString) => {
    this.setState({ dateStart: dateString, isChanged: true });
  };

  handleFilterSubmit = (filterName, clear) => {
    let filterValue = [];
    if (clear !== true) {
      filterValue = this.state[filterName];
      this.setState({ activeFilter: null });
    } else if (filterName === 'dateStart') {
      this.setState({ dateStart: preparePostDateForSubmission(new Date()) });
    } else {
      const value = this.state[filterName].isArray
        ? []
        : filterName === 'tags'
        ? { whatTags: [], whoTags: [], locationTags: [] }
        : typeof this.state[filterName] === 'boolean'
        ? false
        : '';
      this.setState({ [filterName]: value, keywordsInput: '' });
    }
    this.props.handleFilterUpdate(filterValue, filterName);
  };

  handleMultiSelect = (selectedItems, selectCategory, selectAll) => {
    let updatedFilterValues = [...this.state[selectCategory]];
    const overlappingItems = updatedFilterValues.filter((element) => selectedItems.includes(element)).length;

    if (selectAll) {
      updatedFilterValues = selectedItems;
    } else if (overlappingItems > 0) {
      updatedFilterValues = updatedFilterValues.filter((value) => !selectedItems.includes(value));
    } else {
      updatedFilterValues = updatedFilterValues.concat(selectedItems);
    }
    this.setState({ [selectCategory]: updatedFilterValues, locationsOnly: false, isChanged: true });
  };

  handleLocationsSubmit = () => {
    if (this.state.locationsOnly) {
      this.setState({ locations: [] });
      this.handleFilterSubmit('locationsOnly');
    } else {
      this.handleFilterSubmit('locations');
      this.setState({ locationsOnly: false });
    }
  };

  handleTypeSelect = (value, selectCategory) => {
    const updatedValue = this.state[selectCategory] === value ? '' : value;
    this.setState({ [selectCategory]: updatedValue, isChanged: true });
  };

  handleTagsUpdate = (tagsToBeAdded, tagsToBeRemoved, tagCategory) => {
    let ammendedTagList = combineAndDedupArrays(this.state.tags[tagCategory], tagsToBeAdded);
    ammendedTagList = ammendedTagList.filter((tag) => tagsToBeRemoved.includes(tag) === false);
    const updatedTags = updateObject(this.state.tags, {
      [tagCategory]: ammendedTagList,
    });
    this.setState({ tags: updatedTags, isChanged: true });
  };

  handleTagsClear = () => {
    this.setState({ tags: { whatTags: [], whoTags: [], locationTags: [], isChanged: true } });
  };

  handleClickOutside = (e) => {
    if (this.props.show) {
      // if we click is either outside of this component
      // or is on a portion of this component that is not a filter pill or window
      // and a filter window is open, close that filter window and save state
      // otherwise close this LogViewFilters.js component entirely
      if (
        !this.container.current.contains(e.target) ||
        (e.target.className.length > 0 && e.target.className.startsWith('LogViewFilters__FilterButton')) ||
        (e.target.id && e.target.id === 'filters-container')
      ) {
        if (this.state.activeFilter !== null) {
          this.toggleFilter(this.state.activeFilter);
        } else {
          this.props.close();
        }
      }
    }
  };

  render = () => {
    const logFiltersContainerClasses = [classes.LogFiltersContainer];
    const keywordFilterClasses = [classes.Filter];
    const membersFilterClasses = [classes.Filter];
    const startDateFilterClasses = [classes.Filter];
    const seasonsFilterClasses = [classes.Filter];
    const categoriesFilterClasses = [classes.Filter];
    const imagesFilterClasses = [classes.Filter];
    const locationsFilterClasses = [classes.Filter];
    const tagsFilterClasses = [classes.Filter];
    const logsFilterClasses = [classes.Filter];
    const selectedMemberNames =
      this.state.memberIds.length > 0 && this.props.postingAs.KnownUsers && this.props.postingAs.KnownUsers.length > 0
        ? this.state.memberIds.map((memberId) =>
            this.props.postingAs.KnownUsers.find((user) => user.User.UserId === memberId)
              ? this.props.postingAs.KnownUsers.find((user) => user.User.UserId === memberId).User.FirstName
              : [],
          )
        : [];
    const flattenedTags = [];
    const beginningStartDate = this.state.dateStart ? formatDateForDisplay(this.state.dateStart.split(' AND ')[0]) : null;
    const endingStartDate =
      this.state.dateStart && this.state.dateStart.split(' AND ')[1] ? formatDateForDisplay(this.state.dateStart.split(' AND ')[1]) : null;
    Object.keys(this.state.tags).forEach((tagType) => {
      if (this.state.tags[tagType].length > 0) this.state.tags[tagType].forEach((tag) => flattenedTags.push(tag));
    });
    if (this.state.activeFilter === 'keywords') keywordFilterClasses.push(classes.Selected);
    if (this.state.activeFilter === 'memberIds') membersFilterClasses.push(classes.Selected);
    if (this.state.activeFilter === 'dateStart') startDateFilterClasses.push(classes.Selected);
    if (this.state.activeFilter === 'seasons') seasonsFilterClasses.push(classes.Selected);
    if (this.state.activeFilter === 'categories') categoriesFilterClasses.push(classes.Selected);
    if (this.state.activeFilter === 'fileType') imagesFilterClasses.push(classes.Selected);
    if (this.state.activeFilter === 'locations') locationsFilterClasses.push(classes.Selected);
    if (this.state.activeFilter === 'tags') tagsFilterClasses.push(classes.Selected);
    if (this.state.activeFilter === 'logs') logsFilterClasses.push(classes.Selected);
    if (this.props.show) logFiltersContainerClasses.push(classes.Shown);

    return (
      <div ref={this.container} className={logFiltersContainerClasses.join(' ')}>
        <div className={classes.FiltersList}>
          <div className={keywordFilterClasses.join(' ')}>
            <div
              className={
                this.state.activeFilter === 'keywords' || this.state.keywords.length > 0
                  ? [classes.FilterButton, classes.Highlighted].join(' ')
                  : classes.FilterButton
              }
            >
              <span className={classes.FilterPill} onClick={() => this.toggleFilter('keywords')}>
                {this.state.keywords.length === 0 ? 'Keywords' : `Keywords: ${truncateText(this.state.keywordsInput, 41)}`}
              </span>
            </div>
            <div className={classes.FilterModal}>
              <KeywordsFilter
                keywords={this.state.keywordsInput}
                show={this.state.activeFilter === 'keywords'}
                changed={this.keywordsChangedHandler}
                submit={() => this.handleFilterSubmit('keywords')}
                clear={() => this.setState({ keywords: [], keywordsInput: [], isChanged: true })}
                placeholder="Enter keyword(s) separated by commas."
              />
            </div>
          </div>
          <div className={membersFilterClasses.join(' ')}>
            <div
              className={
                this.state.activeFilter === 'memberIds' || this.state.memberIds.length > 0
                  ? [classes.FilterButton, classes.Highlighted].join(' ')
                  : classes.FilterButton
              }
            >
              <span className={classes.FilterPill} onClick={() => this.toggleFilter('memberIds')}>
                {this.state.memberIds.length === 0 ? 'Members' : `Members: ${truncateText(selectedMemberNames.join(', '), 41)}`}
              </span>
            </div>
            <div className={classes.FilterModal}>
              <MembersFilter
                allMembers={this.props.postingAs.KnownUsers}
                selectedMemberIds={this.state.memberIds}
                show={this.state.activeFilter === 'memberIds'}
                select={this.handleMultiSelect}
                submit={() => this.handleFilterSubmit('memberIds')}
                clear={() => this.setState({ memberIds: [], isChanged: true })}
              />
            </div>
          </div>
          <div className={startDateFilterClasses.join(' ')}>
            <div
              className={
                this.props.filters.dateStart && this.props.filters.dateStart.length > 0
                  ? [classes.FilterButton, classes.Highlighted].join(' ')
                  : classes.FilterButton
              }
            >
              <span className={classes.FilterPill} onClick={() => this.toggleFilter('dateStart')}>
                {this.state.dateStart == null || this.state.dateStart.length === 0
                  ? 'Dates'
                  : `Dates: ${beginningStartDate}${endingStartDate ? ` - ${endingStartDate}` : ''}`}
              </span>
            </div>
            <div className={classes.FilterModal}>
              <DatesFilter
                show={this.state.activeFilter === 'dateStart'}
                dateStart={this.state.dateStart}
                handleDateStartChanged={this.handleDateStartChanged}
                submit={() => this.handleFilterSubmit('dateStart')}
                clear={() => this.setState({ dateStart: null, isChanged: true })}
              />
            </div>
          </div>
          <div className={seasonsFilterClasses.join(' ')}>
            <div
              className={
                this.state.activeFilter === 'seasons' || this.state.seasons.length > 0
                  ? [classes.FilterButton, classes.Highlighted].join(' ')
                  : classes.FilterButton
              }
            >
              <span className={classes.FilterPill} onClick={() => this.toggleFilter('seasons')}>
                {this.state.seasons.length === 0 ? 'Seasons' : `Seasons: ${truncateText(this.state.seasons.join(', '), 41)}`}
              </span>
            </div>
            <div className={classes.FilterModal}>
              <SeasonsFilter
                seasons={this.state.seasons}
                show={this.state.activeFilter === 'seasons'}
                select={this.handleMultiSelect}
                submit={() => this.handleFilterSubmit('seasons')}
                clear={() => this.setState({ seasons: [], isChanged: true })}
              />
            </div>
          </div>
          <div className={categoriesFilterClasses.join(' ')}>
            <div
              className={
                this.state.activeFilter === 'categories' || this.state.categories.length > 0
                  ? [classes.FilterButton, classes.Highlighted].join(' ')
                  : classes.FilterButton
              }
            >
              <span className={classes.FilterPill} onClick={() => this.toggleFilter('categories')}>
                {this.state.categories.length === 0 ? 'Categories' : `Categories: ${truncateText(this.state.categories.join(', '), 41)}`}
              </span>
            </div>
            <div className={classes.FilterModal}>
              <CategoriesFilter
                categories={this.state.categories}
                show={this.state.activeFilter === 'categories'}
                select={this.handleMultiSelect}
                submit={() => this.handleFilterSubmit('categories')}
                clear={() => this.setState({ categories: [], isChanged: true })}
              />
            </div>
          </div>
          <div className={imagesFilterClasses.join(' ')}>
            <div
              className={
                this.state.activeFilter === 'fileType' || this.state.fileType.length > 0
                  ? [classes.FilterButton, classes.Highlighted].join(' ')
                  : classes.FilterButton
              }
            >
              <span className={classes.FilterPill} onClick={() => this.toggleFilter('fileType')}>
                {this.state.fileType.length === 0
                  ? 'Images'
                  : this.state.fileType === 'image'
                  ? 'Posts with Images'
                  : this.state.fileType === 'no_image'
                  ? 'Posts Without Images'
                  : 'Posts With Videos'}
              </span>
            </div>
            <div className={classes.FilterModal}>
              <FileTypeFilter
                fileType={this.state.fileType}
                show={this.state.activeFilter === 'fileType'}
                select={this.handleTypeSelect}
                submit={() => this.handleFilterSubmit('fileType')}
                clear={() => this.setState({ fileType: '', isChanged: true })}
              />
            </div>
          </div>
          <div className={locationsFilterClasses.join(' ')}>
            <div
              className={
                this.state.activeFilter === 'locations' || this.state.locations.length > 0 || this.state.locationsOnly
                  ? [classes.FilterButton, classes.Highlighted].join(' ')
                  : classes.FilterButton
              }
            >
              <span className={classes.FilterPill} onClick={() => this.toggleFilter('locations')}>
                {this.state.locations.length === 0 && !this.state.locationsOnly
                  ? 'Locations'
                  : this.state.locationsOnly
                  ? 'Posts with Locations'
                  : `Locations: ${truncateText(this.state.locations.join(', '), 41)}`}
              </span>
            </div>
            <div className={classes.FilterModal}>
              <LocationsFilter
                toggleLocationOnly={this.toggleLocationsOnly}
                show={this.state.activeFilter === 'locations'}
                importantPlaces={this.props.importantPlaces}
                locations={this.state.locations}
                postingAs={this.props.postingAs}
                locationsOnly={this.state.locationsOnly}
                select={this.handleMultiSelect}
                clear={() => this.setState({ locations: [], isChanged: true, locationsOnly: false })}
                submit={() => this.handleLocationsSubmit()}
              />
            </div>
          </div>
          <div className={tagsFilterClasses.join(' ')}>
            <div
              className={
                this.state.activeFilter === 'tags' || flattenedTags.length > 0
                  ? [classes.FilterButton, classes.Highlighted].join(' ')
                  : classes.FilterButton
              }
            >
              <span className={classes.FilterPill} onClick={() => this.toggleFilter('tags')}>
                {flattenedTags.length === 0 ? 'Tags' : `Tags: ${truncateText(flattenedTags.join(', '), 41)}`}
              </span>
            </div>
            <div className={classes.FilterModal}>
              <TagsFilter
                show={this.state.activeFilter === 'tags'}
                tags={this.props.tags}
                selectedTags={this.state.tags}
                updateTags={this.handleTagsUpdate}
                clear={this.handleTagsClear}
                submit={() => this.handleFilterSubmit('tags')}
              />
            </div>
          </div>
        </div>
        <div className={classes.UnreadSelector}>
          <p>Unread Posts Only</p>
          <SliderToggle checked={this.state.unreadOnly} toggle={() => this.toggleBooleanFilter('unreadOnly')} />
        </div>
        <div className={classes.ClearFilters}>
          {this.props.currentLogs ? (
            <span className={classes.Count}>{this.props.currentLogs.PostCount ? this.props.currentLogs.PostCount : 0} Posts</span>
          ) : null}
          <p onClick={this.handleClearAll} className={classes.ClearAll}>
            Clear All
          </p>
        </div>
      </div>
    );
  };
}

export default LogViewFilters;
